import React, {useEffect, useState} from 'react';
import {
    Box,
    Container,
    Typography,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    Paper,
    Alert,
} from '@mui/material'

import PersonIcon from '@mui/icons-material/Person'
import LoginIcon from '@mui/icons-material/Login'

import axios from 'axios';
import { useNavigate } from 'react-router-dom'

const LoginForm = ({ forceRerender }) => {
    const [formData, setFormData] = useState({
        email: '',
        username: '',
        password: '',
        remember: false
    });

    const [errors, setErrors] = useState({});
    const [authMode] = useState('local')
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success')
    const navigate = useNavigate()

    useEffect(() => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('first')
        localStorage.removeItem('last')
    })
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setErrors({});
        setAlertMessage('');

        try{
            const response = await axios.post('https://payments.leviton.com/api/login', {}, {
                headers: {
                    'X-LDAP-Username': formData.username,
                    'X-LDAP-Password': formData.password,
                }
            });
    
            const token = response.data.token;
            const name = response.data.name.split(',');
            const firstName = name[1]
            const lastName = name[0]
            localStorage.setItem('authToken', token)
            localStorage.setItem('first', firstName)
            localStorage.setItem('last', lastName)
            
            forceRerender();

            navigate('/home');
            } catch (err) {
                setAlertMessage('Invalid username or password')
                setAlertType('error')
                console.log('ffff', err)
            }
        };

    return (
        <Container component='main' maxWidth='sm'>
            <Paper elevation={3} sx={{padding: 4, marginTop: 4}}>
                <Box display='flex' alignItems='center' mb={2}>
                    <PersonIcon color='primary'>
                        <Typography variant='h5' component='h1' m1={1}>
                            Login
                        </Typography>
                    </PersonIcon>
                </Box>
                {alertMessage && (
                    <Alert severity={alertType} sx={{ mb: 2}}>
                        {alertMessage}
                    </Alert>
                )}
                <form onSubmit={handleSubmit}>
                    {authMode === 'local' && (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    variant='outlined'
                                    fullWidth
                                    id = 'username'
                                    label='Username'
                                    name='username'
                                    value={formData.username}
                                    onChange={handleChange}
                                    error={!!errors.username}
                                    helperText={errors.username}
                                    />
                            </Grid>
                        </Grid>
                    )}
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12}>
                                <TextField
                                    variant='outlined'
                                    fullWidth
                                    id = 'password'
                                    label='Password'
                                    name='password'
                                    type='password'
                                    value={formData.password}
                                    onChange={handleChange}
                                    error={!!errors.passwprd}
                                    helperText={errors.password}
                                    />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={formData.remember}
                                            onChange={handleChange}
                                            name='remember'
                                            color='primary'
                                        />
                                    }
                                    label='Remember Me'
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    type='submit'
                                    variant='contained'
                                    color='success'
                                    fullWidth
                                    startIcon={<LoginIcon/>}
                                    
                                    >
                                        Login
                                    </Button>
                            </Grid>
                        </Grid>
                </form>
            </Paper>
        </Container>
    );

};

export default LoginForm;

